import React, { useState, useEffect } from 'react';
import ReactAudioPlayer from 'react-audio-player';
import { useTranslation } from "react-i18next";
import Swal from 'sweetalert2';
import axios from "axios";
import { useAuth } from '../../../../../context/AuthContext';
import { useParams } from "react-router-dom";
import ReactPlayer from 'react-player';
import "./DynamicSentence.css";
import './matchcss.css';
import useSubjectName from './useSubjectName';
import useAttemptTracker, { MAX_FRONTEND_ATTEMPTS } from './useAttemptTracker';
import { API_BASE_URL } from '../../../../../Helpers/apiConfig';

const Sentence = (props) => {
    const { t } = useTranslation();
    const [hasMediaContent, sethasMediaContent] = useState([]);
    const [questionTitle, setQuestionTitle] = useState([]);
    const [questionText, setQuestionText] = useState([]);
    const [parts, setParts] = useState([]);
    const [answers, setAnswers] = useState([]);
    const [obj, setObj] = useState([]);
    const [answ, setAnsw] = useState([]);
    const [url, setUrl] = useState([]);
    const [soundurl, setSoundurl] = useState([]);

    const [ans, setAns] = useState([]);
    const [sentenceText, setSentenceText] = useState("");
    const [sentenceAnswers, setSentenceAnswers] = useState([]);
    const { user } = useAuth();
    const params = useParams();
    const [imageDimensions, setImageDimensions] = useState({ width: 0, height: 0 });
    const subjectName = useSubjectName();
    const { getAttempt, registerWrongAttempt, clearAttempt } = useAttemptTracker(props.questionNumber);

    const getDynamicPadding = () => {
        const ratio = imageDimensions.width / imageDimensions.height;
        if (ratio > 1) {
            return { paddingTop: "10px", paddingBottom: "10px" };
        } else if (ratio < 1) {
            return { paddingLeft: "10px", paddingRight: "10px" };
        }
        return {};
    };

    const Request = async (userAnswer) => {
        try {
            const headerss = {
                "accept": "*/*",
                'Content-Type': 'application/json',
                'Access-Control-Allow-Credentials': 'false',
                'Authorization': 'Bearer ' + user.token
            };
            let url = `${API_BASE_URL}/user/Content/Answer`;

            await axios({
                method: 'POST',
                url: url,
                params: {
                    courseId: Number(params.courseid),
                    question: Number(props.data.id),
                    answer: userAnswer.toString()
                },
                headers: headerss
            }).then(res => {
                clearAttempt();

                if (res.data['success']) {
                    props.playCorrectSound?.();
                    Swal.fire({
                        title: "Başarılı!",
                        icon: "success",
                        confirmButtonText: `Tamam`,
                        timer: 3000,
                    }).then(() => {
                        let newurl = Number(params['id']) + 1;
                        window.location.href =
                            "/user/course/question/" + params['courseid'] + "/" + params['subjectid'] + "/" + newurl;
                    });
                } else {
                    if (res.data['alertType'] === "question") {
                        props.playLastIncorrectSound?.();
                        Swal.fire({
                            title: "Hatalı cevap",
                            text: props.data.notfyText,
                            icon: "error",
                            confirmButtonText: `Tamam`,
                        }).then(() => {
                            let newurl = Number(params['id']) + 1;
                            window.location.href =
                                "/user/course/question/" + params['courseid'] + "/" + params['subjectid'] + "/" + newurl;
                        });
                    } else {
                        let errorMsg = res['data']['message'];
                        props.playLastIncorrectSound?.();
                        Swal.fire({
                            title: "Hata",
                            text: errorMsg,
                            icon: "error",
                            confirmButtonText: `Tamam`,
                        }).then(() => {
                            let newurl = Number(params['id']) + 1;
                            window.location.href =
                                "/user/course/question/" + params['courseid'] + "/" + params['subjectid'] + "/" + newurl;
                        });
                    }
                }
            });
        } catch (err) {
            console.log(err.message);
        }
    };

    const handleSubmit = (e) => {
        e.preventDefault();

        if (!props.isActiveContent) {
            Swal.fire({
                icon: "error",
                title: "Aktif Sorunuz Değil",
                text: "Bu soruyu çözebilmek için önce sırasındaki soruları tamamlamalısınız.",
                confirmButtonText: "Tamam"
            });
            return;
        }

        const formData = new FormData(e.target);

        const selectedIndexes = [];

        for (let [key, value] of formData.entries()) {
            if (key.startsWith("blank_")) {
                selectedIndexes.push(value);
            }
        }

        const result = selectedIndexes.join(",");
        const attempt = getAttempt();
        const correctAnswer = props.data.answer;

        if (attempt < MAX_FRONTEND_ATTEMPTS - 1) {
            if (result === correctAnswer) {
                Request(result);
            } else {
                registerWrongAttempt();

                if (attempt === MAX_FRONTEND_ATTEMPTS - 2) {
                    props.playLastIncorrectSound?.();
                } else {
                    props.playFirstIncorrectSound?.();
                }

                Swal.fire({
                    title: attempt === MAX_FRONTEND_ATTEMPTS - 2 ? "Son bir kez deneyiniz!" : "Tekrar Deneyiniz!",
                    text: props.data.notfyText,
                    icon: "warning",
                }).then(() => window.location.reload());
            }
            return;
        }

        Request(result);
    };

    useEffect(() => {
        const parsedContent = JSON.parse(props.data.contentStr || "{}");
        const parsedDetail = JSON.parse(props.data.detail || "[]");

        setObj(parsedContent);

        const text = parsedContent?.text || "";
        const [title = "", textPart = ""] = text.split("__");

        setQuestionTitle(title);
        setQuestionText(textPart);

        const mediaTypes = ["sound", "video", "image", "image_sound"];
        sethasMediaContent(mediaTypes.includes(parsedContent?.type));

        setAnsw(parsedDetail);
        setAns(parsedDetail);
        setSentenceText(textPart);
        setSentenceAnswers(parsedDetail);
        setParts(textPart ? textPart.split("_") : []);

        if (parsedContent?.type === "image_sound") {
            setUrl(parsedContent?.url || "");
            setSoundurl(parsedContent?.soundUrl || "");
        } else {
            setUrl(parsedContent?.url || parsedContent?.url1 || "");
            setSoundurl("");
        }
    }, []);

    return (
        <div className="sentence-page">
            <span style={{ color: "black" }}>
                <b><i>{subjectName}</i></b>
            </span>
            <br />
            <br />

            <div className="sentence-header">
                {obj['type'] === "image_sound" ? (
                    <div className="sentence-media-stack">
                        <div className="sentence-media-wrap sentence-audio-wrap">
                            <div className="sentence-media-inner sentence-audio-inner">
                                <ReactAudioPlayer
                                    src={url}
                                    autoPlay={false}
                                    controls={true}
                                    controlsList="nodownload "
                                />
                            </div>
                        </div>

                        <br />

                        <div className="sentence-media-wrap">
                            <div
                                className="sentence-image-wrap"
                                style={{ ...getDynamicPadding() }}
                            >
                                <img
                                    src={soundurl}
                                    alt="Question Media"
                                    className="sentence-image"
                                />
                            </div>
                        </div>
                    </div>
                ) : null}

                {obj['type'] === "sound" ? (
                    <div className="sentence-media-wrap sentence-audio-wrap">
                        <div className="sentence-media-inner sentence-audio-inner">
                            <ReactAudioPlayer
                                src={url}
                                autoPlay={false}
                                controls={true}
                                controlsList="nodownload "
                            />
                        </div>
                    </div>
                ) : null}

                {obj['type'] === "video" ? (
                    <div className="sentence-media-wrap sentence-video-outer">
                        <div className="sentence-video-wrap">
                            <ReactPlayer
                                className='react-player'
                                width="100%"
                                height="100%"
                                url={url}
                                config={{
                                    file: {
                                        attributes: {
                                            controlsList: "nodownload",
                                            disablePictureInPicture: true
                                        }
                                    }
                                }}
                            />
                        </div>
                    </div>
                ) : null}

                {obj['type'] === "image" ? (
                    <div className="sentence-media-wrap">
                        <div
                            className="sentence-image-wrap"
                            style={{ ...getDynamicPadding() }}
                        >
                            <img
                                src={url}
                                alt="Question Media"
                                className="sentence-image"
                            />
                        </div>
                    </div>
                ) : null}

                {!(obj['type'] === "sound" || obj['type'] === "video" || obj['type'] === "image" || obj['type'] === "image_sound") && (
                    <>
                        <br />
                        <br />
                    </>
                )}

                <b className="sentence-title">
                    {questionTitle}
                </b>

                <br /><br />
            </div>

            <div className="sentence-form-wrap">
                <form onSubmit={handleSubmit} className="sentence-form">
                    <div className="sentence-line">
                        {parts.map((part, index) => (
                            <React.Fragment key={index}>
                                <span className="sentence-part">{part}</span>

                                {index < parts.length - 1 && sentenceAnswers[index] && (
                                    <select
                                        name={`blank_${index}`}
                                        className="dynamic-select sentence-select"
                                        defaultValue=""
                                        data-blank-index={index}
                                        onChange={() => props.playChoiceSentenceSound?.()}
                                        required
                                    >
                                        <option value="" disabled hidden>
                                            Seçim yapınız
                                        </option>

                                        {sentenceAnswers[index].service.map((opt, i) => (
                                            <option key={i} value={i + 1}>
                                                {opt}
                                            </option>
                                        ))}
                                    </select>
                                )}
                            </React.Fragment>
                        ))}
                    </div>

                    <br />

                    {props.answered ? (
                        <div style={{ display: "flex", justifyContent: "center", width: "100%" }}>
                            <b style={{ fontSize: "15px" }}>
                                <i>{props.realanswer}</i> cevaplanmış soru.
                            </b>
                        </div>
                    ) : (
                        <div className='sentence-submit-wrap'>
                            <button type="submit" className="save-btn">
                                {t("saveAndContinue")}
                            </button>
                        </div>
                    )}
                </form>
            </div>
        </div>
    );
};

export default Sentence;